import { getLocale } from "@/lib/i18n";

// GA-UI-1 D2 — the ONE author of every printed application name on the web.
// Mirrors backend report_v3/i18n.py `application_label`: known dropdown values
// are translated, unknown strings pass through, the code "other" prints the
// buyer's own text (or "Other" / "Autre"), never the raw code.
export const APPLICATION_OTHER = "other";

const OTHER_LABEL = { en: "Other", fr: "Autre" };

const FR = {
  "Manufacturing plant": "Usine de fabrication",
  "Warehouse / logistics": "Entrepôt / logistique",
  "Agro-processing": "Agro-transformation",
  "Cement / heavy industry": "Cimenterie / industrie lourde",
  "Cold chain / food": "Chaîne du froid / agroalimentaire",
  "Open-pit mine": "Mine à ciel ouvert",
  "Underground mine": "Mine souterraine",
  "Processing plant": "Usine de traitement",
  "Camp & offices": "Base vie & bureaux",
  "Exploration site": "Site d'exploration",
  "Independent power producer (IPP)": "Producteur indépendant d'électricité (IPP)",
  "Distribution utility": "Société de distribution d'électricité",
  "Mini-grid operator": "Opérateur de mini-réseau",
  "Grid-connected renewable": "Centrale renouvelable raccordée au réseau",
  "Macro tower site": "Site macro (pylône)",
  "Regional aggregation site": "Site d'agrégation régional",
  "Data centre / edge": "Centre de données / edge",
  "Fibre network hub": "Nœud de réseau fibre",
};

export function applicationLabel(input, lang = getLocale()) {
  const l = String(lang || "en").toLowerCase().startsWith("fr") ? "fr" : "en";
  const app = String((input && input.application) || "").trim();
  if (!app) return "";
  if (app === APPLICATION_OTHER) {
    return String((input && input.application_other_text) || "").trim() || OTHER_LABEL[l];
  }
  return l === "fr" ? FR[app] || app : app;
}
